import { Clock } from "lucide-react";
import { Section, SectionHeading, Card } from "./service-revops-ui";
import { SectionCta } from "./service-revops-section-cta";
import { gohighlevelConfig as defaultConfig } from "./service-platform-config";
import type { PlatformConfig } from "./service-platform-config";

export function ServiceCostAndProcess({
  config = defaultConfig,
}: {
  config?: PlatformConfig;
} = {}) {
  return (
    <>
      {/* §4 COST OF INACTION */}
      <Section>
        <SectionHeading
          eyebrow={config.costEyebrow}
          navy={config.costHeadlineNavy}
          blue={config.costHeadlineBlue}
        />
        <div className="grid md:grid-cols-3 gap-6">
          {config.costs.map((c, i) => (
            <Card key={i}>
              <div className="text-center">
                <div
                  className="font-display font-extrabold mb-3"
                  style={{
                    fontSize: "clamp(32px, 3.4vw, 44px)",
                    lineHeight: 1.05,
                    color: "#0B7CF2",
                    letterSpacing: "-0.04em",
                  }}
                >
                  {c.stat}
                </div>
                <p
                  style={{
                    fontSize: "15px",
                    lineHeight: 1.55,
                    color: "#536B89",
                  }}
                >
                  {c.desc}
                </p>
              </div>
            </Card>
          ))}
        </div>
        <p
          className="text-center mt-10 font-display font-bold max-w-2xl mx-auto"
          style={{
            fontSize: "20px",
            lineHeight: 1.4,
            color: "#071E61",
            letterSpacing: "-0.02em",
          }}
        >
          {config.costConclusion}
        </p>
      </Section>

      {/* §5 BUILD PROCESS */}
      <Section>
        <SectionHeading
          eyebrow={config.processEyebrow}
          navy={config.processHeadlineNavy}
          blue={config.processHeadlineBlue}
          sub={config.processSub}
        />
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {config.processSteps.map((s, i) => (
            <Card key={i}>
              <div
                className="font-display font-black mb-4 select-none"
                style={{
                  fontSize: "44px",
                  lineHeight: 1,
                  color: "rgba(17,143,247,0.16)",
                  letterSpacing: "-0.05em",
                }}
              >
                0{i + 1}
              </div>
              <h3
                className="font-display font-bold mb-1"
                style={{
                  fontSize: "19px",
                  color: "#071E61",
                  letterSpacing: "-0.02em",
                }}
              >
                {s.title}
              </h3>
              <div
                className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 mb-3 font-sans font-bold"
                style={{
                  fontSize: "11.5px",
                  background: "#EAF5FF",
                  color: "#0B7CF2",
                }}
              >
                <Clock className="w-3 h-3" />
                {s.timeline}
              </div>
              <p
                style={{
                  fontSize: "14.5px",
                  lineHeight: 1.55,
                  color: "#536B89",
                }}
              >
                {s.desc}
              </p>
            </Card>
          ))}
        </div>
        <SectionCta
          copy={config.processCtaCopy}
          label={config.processCtaLabel}
        />
      </Section>
    </>
  );
}
